"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CALL_API = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _queryString = require("query-string");

var _queryString2 = _interopRequireDefault(_queryString);

var _isomorphicFetch = require("isomorphic-fetch");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _config = require("../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CALL_API = exports.CALL_API = Symbol("Call API");

exports.default = function (store) {
  return function (next) {
    return function (action) {
      var callAPI = action[CALL_API];

      if (typeof callAPI === "undefined") {
        return next(action);
      }

      var endpoint = callAPI.endpoint,
          types = callAPI.types,
          authenticated = callAPI.authenticated,
          query = callAPI.query,
          method = callAPI.method,
          body = callAPI.body,
          content = callAPI.content;

      var _types = _slicedToArray(types, 3),
          requestType = _types[0],
          successType = _types[1],
          errorType = _types[2];

      next({
        type: requestType
      });
      var authId = store.getState().global.authId;
      return callApi(endpoint, authenticated, method, body, query, content, authId).then(function (response) {
        return next({
          data: response.Data,
          authenticated: authenticated,
          type: successType
        });
      }, function (error) {
        return next({
          error: error.message || "There was an error.",
          type: errorType
        });
      });
    };
  };
};

function callApi(endpoint, authenticated, method, body, query, content, authId) {
  var commonRequestParams = {
    Language: "de",
    Country: "DE"
  };

  if (authenticated) {
    if (!authId) {
      throw "No authId found!";
    }

    commonRequestParams.AuthId = authId;
  }

  var url = _config2.default.getKey("apiUrl") + endpoint;

  if (method === "POST") {
    body = _extends({}, body, commonRequestParams, {
      ConfigurationId: authId
    });
  } else {
    var foo = {
      r: JSON.stringify(_extends({}, commonRequestParams, query))
    };
    url += foo ? "?" + _queryString2.default.stringify(foo) : "";
  }

  var config = {
    mode: "cors",
    headers: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": content || "application/json; charset=utf-8"
    },
    method: method,
    body: JSON.stringify(body)
  };
  return (0, _isomorphicFetch2.default)(url, config).then(function (response) {
    var responseCopy = response.clone();
    return responseCopy.json().catch(function (_) {
      return response.text();
    }).then(function (text) {
      return {
        text: text,
        response: response
      };
    });
  }).then(function (_ref) {
    var text = _ref.text,
        response = _ref.response;

    if (!response.ok) {
      return Promise.reject(text);
    }

    var statusCode = text.Status.Code;

    if ([200, 201, 202, 204].indexOf(statusCode) === -1) {
      return Promise.reject(text);
    }

    return text;
  }).catch(function (err) {
    return Promise.reject(err);
  });
} //builds a url with weird formed query string that the SL can understand (sic!)


function buildRequestUrl(query, authenticated, authId, endpoint) {
  var requestData = _extends({}, query, {
    Language: "de",
    Country: "DE"
  });

  if (authenticated) {
    if (!authId) {
      throw "No authId found!";
    }

    requestData.AuthId = authId;
  }

  if (authId) {
    query = {
      r: JSON.stringify(requestData)
    };
  }

  var url = BASE_URL + endpoint;
  url += query ? "?" + _queryString2.default.stringify(query) : "";
  return url;
}